import { Action } from "VSS/Flux/Action";

import { ActionsHubBase, IEmptyActionPayload } from "DistributedTaskControls/Common/Actions/Base";
import { ActionsKeys } from "DistributedTaskControls/Common/Common";
import * as Types from "DistributedTaskControls/Phase/Types";

import { TaskAgentQueue } from "TFS/DistributedTask/Contracts";

export interface IActionQueuesPayload {
    agentQueueFromBuild: TaskAgentQueue;
    queues: TaskAgentQueue[];
    agentSpecifications?: Types.IAgentSpecification[];
    currentQueueId?: number;
    currentAgentSpecification?: Types.IAgentSpecification;
    forceUpdate?: boolean;
}

export interface IActionEditDefintionQueuesPayload {
    permissibleQueues: TaskAgentQueue[];
    allQueues: TaskAgentQueue[];
}

export interface IUpdateAgentQueuePayload {
    selectedQueueId: number;
    agentSpecifications?: Types.IAgentSpecification[];
    currentAgentSpecification?: Types.IAgentSpecification;
}

export class AgentsActions extends ActionsHubBase {

    public initialize(): void {
        this._createAgentsQueueSection = new Action<IActionQueuesPayload>();
        this._updateAgentsQueueSection = new Action<IActionQueuesPayload>();
        this._updateAgentQueue = new Action<number>();
        this._updateAgentQueueWithSpecifications = new Action<IUpdateAgentQueuePayload>();
        this._refreshAgentQueue = new Action<TaskAgentQueue[]>();
        this._manageAgent = new Action<IEmptyActionPayload>();
        this._initializeAgentQueues = new Action<IActionEditDefintionQueuesPayload>();
        this._updateAgentSpecifications = new Action<Types.IAgentSpecification[]>();
        this._updateSelectedAgentSpecification = new Action<Types.IAgentSpecification>();
        this._updateLoadingAgentSpecifications = new Action<boolean>();
    }

    public static getKey(): string {
        return ActionsKeys.AgentsActions;
    }

    public get manageAgent(): Action<IEmptyActionPayload> {
        return this._manageAgent;
    }

    public get createAgentsQueueSection(): Action<IActionQueuesPayload> {
        return this._createAgentsQueueSection;
    }

    public get updateAgentsQueueSection(): Action<IActionQueuesPayload> {
        return this._updateAgentsQueueSection;
    }

    public get updateAgentQueue(): Action<number> {
        return this._updateAgentQueue;
    }

    public get updateAgentQueueWithSpecifications(): Action<IUpdateAgentQueuePayload> {
        return this._updateAgentQueueWithSpecifications;
    }

    public get refreshAgentQueue(): Action<TaskAgentQueue[]> {
        return this._refreshAgentQueue;
    }

    public get initializeAgentQueues(): Action<IActionEditDefintionQueuesPayload> {
        return this._initializeAgentQueues;
    }

    public get updateAgentSpecifications(): Action<Types.IAgentSpecification[]> {
        return this._updateAgentSpecifications;
    }

    public get updateSelectedAgentSpecification(): Action<Types.IAgentSpecification> {
        return this._updateSelectedAgentSpecification;
    }

    public get updateLoadingAgentSpecifications(): Action<boolean> {
        return this._updateLoadingAgentSpecifications;
    }

    private _createAgentsQueueSection: Action<IActionQueuesPayload>;
    private _updateAgentsQueueSection: Action<IActionQueuesPayload>;
    private _updateAgentQueue: Action<number>;
    private _updateAgentQueueWithSpecifications: Action<IUpdateAgentQueuePayload>;
    private _updateLoadingAgentSpecifications: Action<boolean>;
    private _refreshAgentQueue: Action<TaskAgentQueue[]>;
    private _initializeAgentQueues: Action<IActionEditDefintionQueuesPayload>;
    private _manageAgent: Action<IEmptyActionPayload>;
    private _updateAgentSpecifications: Action<Types.IAgentSpecification[]>;
    private _updateSelectedAgentSpecification: Action<Types.IAgentSpecification>;
}
